var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"mr-2",attrs:{"items":_vm.searchItems,"item-value":"id","item-text":"name","placeholder":_vm.placeholder,"label":_vm.label,"clearable":"","outlined":"","dense":"","rules":_vm.requiredFieldRule},on:{"change":_vm.onChangeHandler},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }